import React, { forwardRef } from 'react'
import { connect } from 'react-redux'

import useCheapestOfTourV2Offer from 'hooks/TourV2/useCheapestOfTourV2Offer'
import TourV2CardContent from './TourV2CardContent'

interface Props {
  currency: string
  offer: App.Tours.TourV2Offer | App.Tours.TourV2OfferSummary
  linkQuery?: URLSearchParams
  onClick?: (offer: App.Tours.TourV2Offer | App.Tours.TourV2OfferSummary) => void
  aspectRatio?: string
  source?: string
  className?: string
  target?: '_blank'
}

const TourV2CardContainer = forwardRef<HTMLAnchorElement, Props>(
  function TourV2CardContainer(props: Props, ref) {
    const { cheapestPurchasableOption, cheapestVariation } =
      useCheapestOfTourV2Offer(props.offer)

    if (!cheapestPurchasableOption || !cheapestVariation) {
      return null
    }

    return (
      <TourV2CardContent
        className={props.className}
        purchasableOption={cheapestPurchasableOption}
        variation={cheapestVariation}
        currency={props.currency}
        offer={props.offer}
        onClick={props.onClick}
        linkQuery={props.linkQuery}
        source={props.source}
        target={props.target}
        ref={ref}
      />
    )
  },
)

function mapState(state: App.State) {
  return {
    currency: state.geo.currentCurrency,
  }
}

export default connect(mapState, null, null, { forwardRef: true })(
  TourV2CardContainer,
)
